import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Shared/Models/CustomFilterModels";

export enum LegalFilter {
    All,
    Confirmed
}

export enum LegalOrder {
    None,
    LegalCode,
    TypeDescr,
    CaseName,
    AppReceivedDate,
    Priority,
    Status,
    TargetDate
}

export class LegalConsulteeModel {
    Stage: number;
    LegalCode: string;
    Ref: string;
    Affiliation?: string;
    OrderConsultDate?: string;
    OrderOppose?: Boolean;
    Withdrawn?: Boolean;
    Views?: string;
}